import * as logger from "OK/logger";
import * as JavascriptModuleResolver from "OK/JavascriptModuleResolver";

const LOGGER_KEY = 'rb-sync';

/**
 * RB - РБ, "рекламные баннеры"
 * Грузит библиотеку https://ad.mail.ru/static/sync-loader.js и "прокидывает" ok_id в rb_sync
 *
 * Документация и исходники здесь: https://gitlab.corp.mail.ru/adtech/webads/fingerprint
 * Графики: https://charts.odkl.ru/reports?id=1451270
 */
export class FingerprintJS {

    activate(element: HTMLElement) {
        const url = element.getAttribute('data-url')!;
        JavascriptModuleResolver.load(url)
            .then(() => {
                logger.success(LOGGER_KEY, 'load');
                this.setOkId(element);
            })
            .catch((e) => {
                OK.Tracer.error(e);
                logger.error(LOGGER_KEY, 'load');
            });
    }

    setOkId(element: HTMLElement) {
        const attrValue = element.getAttribute('data-uid');
        if (!attrValue) {
            return;
        }
        const userId = parseInt(attrValue, 10);
        if (!userId) {
            OK.Tracer.error(new Error('Unknown user in FingerprintJS module'));
            return;
        }
        try {
            let errType;
            if (!window.rb_sync) {
                errType = 'undefRbSync';
            } else if (!(typeof window.rb_sync.setOkId === 'function')) {
                errType = 'undefSetOkId';
            }
            if (!errType) {
                window.rb_sync.setOkId(userId);
                logger.success(LOGGER_KEY, 'setOkId');
            } else {
                logger.success(LOGGER_KEY, errType);
            }
        } catch (e) {
            OK.Tracer.error(e);
            logger.error(LOGGER_KEY, 'setOkId');
        }
    }
}
